// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"eb6129cc","977":"f8901cae"}[chunkId] + ".chunk.js";
};